import { ReactNode } from 'react';
import styled from '@emotion/styled';
import ContentCard from '../cards/ContentCard/ContentCard';
import { Css, IImagePosition, ILinkItemType, Responsive } from '../../../ui';

export interface IHighlightContentProps {
	title: string;
	subtitle?: string;
	body?: ReactNode | string;
	linkHref?: string;
	linkTitle?: string;
	imagePosition?: Responsive.IValueOrResponsiveValue<IImagePosition>;
	linkType?: ILinkItemType;
}

export function HighlightContent({
	title,
	subtitle,
	body,
	linkHref,
	linkTitle,
	imagePosition,
	linkType,
}: IHighlightContentProps) {
	return (
		<HighlightContentWrap imagePosition={imagePosition}>
			<ContentCard
				title={title}
				subtitle={subtitle}
				body={body}
				buttonLabel={linkTitle}
				buttonLink={linkHref}
				linkType={linkType}
			/>
		</HighlightContentWrap>
	);
}

const HighlightContentWrap = styled.div<{
	imagePosition?: IHighlightContentProps['imagePosition'];
}>`
	margin-left: ${({ imagePosition }) => {
		if (imagePosition && imagePosition[0] === 'first') return '-34px';
		return 0;
	}};
	margin-right: ${({ imagePosition }) => {
		if (imagePosition && imagePosition[0] === 'last') return '-34px';
		return 0;
	}};

	padding: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 565px;

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		${({ imagePosition }) =>
			imagePosition && imagePosition[0] === 'first'
				? `margin-right: ${Css.pxToRem(24)};`
				: `margin-left: ${Css.pxToRem(24)};`}
		padding: 0;
		width: 50%;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
		margin: -100px auto;
		padding: 0 ${Css.pxToRem(16)};
	}
`;
